import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import ProjectInstallmentFundingConditionApproval
  from "../../../interfaces/project-installment-funding-condition-approval";
import ProjectInstallmentFundingConditionApprovalStatus
  from "../../../interfaces/project-installment-funding-condition-approval-status";
import {FormControl} from "@angular/forms";
import {EquityInstallmentService, UpdateInstallmentObservableMode} from "../../equity-installment.service";
import {ConfirmationModalComponent} from "../../../components/confirmation-modal/confirmation-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {Subscription} from "rxjs";
import Permission from "../../../interfaces/permission";

@Component({
    selector: 'equity-installment-approval',
    templateUrl: './equity-installment-approval.component.html',
    styleUrls: ['./equity-installment-approval.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentApprovalComponent implements OnInit{
  @Input() approval: ProjectInstallmentFundingConditionApproval
  @Input() readonly:boolean = false;
  @Input() statuses: ProjectInstallmentFundingConditionApprovalStatus[]  = []
  public statusFormControl: FormControl = new FormControl(null)
  public readOnlyStatus: string;
  private userSub: Subscription;
  public user:any;
  public permissionSub: Subscription
  public permissions: any;

  constructor(private equityService: EquityInstallmentService, private dialog: MatDialog) {
  }

  ngOnInit() {

    if(this.approval.projectInstallmentFundingConditionApprovalStatus!==null){
      this.statusFormControl.setValue(this.approval.projectInstallmentFundingConditionApprovalStatus?.id)
      this.readOnlyStatus = this.approval.projectInstallmentFundingConditionApprovalStatus.name
    }
    this.userSub = this.equityService.user$.subscribe((result) => this.user = result)
    this.permissionSub = this.equityService.permissions$.subscribe((result) => this.permissions = result)
    this.statusFormControl.valueChanges.subscribe((val:any) => {
      this.equityService.updateApprovalStatus(this.approval.id, val, this.user.id).subscribe((result) => {
        this.equityService.openSnackBar('Approval updated.', 'save-success')
        let rs = result as any;
        let resultData = rs.data.updateConditionApproval
        this.equityService.updateConditionApprovals(UpdateInstallmentObservableMode.UPDATE, resultData)
      } )
    })
  }

  public openDeleteConfirmationModal(){
    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '600px',
      height: '200px',
      data: {
        modalTitle: 'Delete Approval',
        actionMessage: 'Are you sure you want to remove this approval?',
      }
    })

    dialogRef.afterClosed().subscribe((data) => {
      if(data.clicked === 'Ok'){
        this.equityService.deleteApproval(this.approval.id).subscribe((response:any) => {
          this.equityService.openSnackBar('Approval removed.', 'save-success')
          let rs = response as any;
          let resultData = rs.data.deleteConditionApproval
          this.equityService.updateConditionApprovals(UpdateInstallmentObservableMode.REMOVE, resultData)
        })
      }
    })
  }

  public checkPermissions(permission:Permission, key: keyof Permission){
    return this.equityService.checkPermissions(permission, key)
  }

  ngOnDestroy(){
    this.userSub.unsubscribe();
    this.permissionSub.unsubscribe();
  }

}
